/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ContentType } from "./http-client";
export class Rentals {
  http;
  constructor(http) {
    this.http = http;
  }
  /**
   * @description Generate a new rental contract based on an approved application.
   *
   * @tags Rentals
   * @name CreateContract
   * @summary Create Contract
   * @request POST:/api/rentals/contracts
   * @secure
   */
  createContract = (data, params = {}) =>
    this.http.request({
      path: `/api/rentals/contracts`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieve all contracts for the organization (Management Only).
   *
   * @tags Rentals
   * @name GetAllContracts
   * @summary List Contracts
   * @request GET:/api/rentals/contracts
   * @secure
   */
  getAllContracts = (query, params = {}) =>
    this.http.request({
      path: `/api/rentals/contracts`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieve a paginated list of contracts (Management Only).
   *
   * @tags Rentals
   * @name GetAllContractsPaged
   * @summary List Contracts (Paged)
   * @request GET:/api/rentals/contracts/paged
   * @secure
   */
  getAllContractsPaged = (query, params = {}) =>
    this.http.request({
      path: `/api/rentals/contracts/paged`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieve only contracts where current user is the tenant.
   *
   * @tags Rentals
   * @name GetMyContracts
   * @summary Get My Contracts
   * @request GET:/api/rentals/contracts/my
   * @secure
   */
  getMyContracts = (params = {}) =>
    this.http.request({
      path: `/api/rentals/contracts/my`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Revokes previous share links for this contract and returns a new public URL (``/share/{token}``).
   *
   * @tags Rentals
   * @name CreateContractPublicShareLink
   * @summary Create or rotate public share link
   * @request POST:/api/rentals/contracts/{contract_id}/public-share-link
   * @secure
   */
  createContractPublicShareLink = (contractId, params = {}) =>
    this.http.request({
      path: `/api/rentals/contracts/${contractId}/public-share-link`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieve a specific contract by its ID.
   *
   * @tags Rentals
   * @name GetContract
   * @summary Get Contract
   * @request GET:/api/rentals/contracts/{contract_id}
   * @secure
   */
  getContract = (contractId, params = {}) =>
    this.http.request({
      path: `/api/rentals/contracts/${contractId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update contract terms during the negotiation phase.
   *
   * @tags Rentals
   * @name UpdateContract
   * @summary Update Contract
   * @request PUT:/api/rentals/contracts/{contract_id}
   * @secure
   */
  updateContract = (contractId, data, params = {}) =>
    this.http.request({
      path: `/api/rentals/contracts/${contractId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Mark a contract as active (usually after it has been signed by all parties).
   *
   * @tags Rentals
   * @name ActivateContract
   * @summary Activate Contract
   * @request PUT:/api/rentals/contracts/{contract_id}/activate
   * @secure
   */
  activateContract = (contractId, params = {}) =>
    this.http.request({
      path: `/api/rentals/contracts/${contractId}/activate`,
      method: "PUT",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Terminate an active contract.
   *
   * @tags Rentals
   * @name TerminateContract
   * @summary Terminate Contract
   * @request PUT:/api/rentals/contracts/{contract_id}/terminate
   * @secure
   */
  terminateContract = (contractId, params = {}) =>
    this.http.request({
      path: `/api/rentals/contracts/${contractId}/terminate`,
      method: "PUT",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Add a comment or observation to the contract negotiation history.
   *
   * @tags Rentals
   * @name AddComment
   * @summary Add Comment
   * @request POST:/api/rentals/contracts/{contract_id}/comments
   * @secure
   */
  addComment = (contractId, data, params = {}) =>
    this.http.request({
      path: `/api/rentals/contracts/${contractId}/comments`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Schedule a move-in for a rental.
   *
   * @tags Rentals
   * @name ScheduleMoveIn
   * @summary Schedule Move In
   * @request POST:/api/rentals/{rental_id}/move-in
   * @secure
   */
  scheduleMoveIn = (rentalId, data, params = {}) =>
    this.http.request({
      path: `/api/rentals/${rentalId}/move-in`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Get move-in details for a rental.
   *
   * @tags Rentals
   * @name GetMoveIn
   * @summary Get Move In
   * @request GET:/api/rentals/{rental_id}/move-in
   * @secure
   */
  getMoveIn = (rentalId, params = {}) =>
    this.http.request({
      path: `/api/rentals/${rentalId}/move-in`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update move-in details.
   *
   * @tags Rentals
   * @name UpdateMoveIn
   * @summary Update Move In
   * @request PATCH:/api/rentals/{rental_id}/move-in
   * @secure
   */
  updateMoveIn = (rentalId, data, params = {}) =>
    this.http.request({
      path: `/api/rentals/${rentalId}/move-in`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Mark move-in as completed.
   *
   * @tags Rentals
   * @name CompleteMoveIn
   * @summary Complete Move In
   * @request POST:/api/rentals/{rental_id}/move-in/complete
   * @secure
   */
  completeMoveIn = (rentalId, params = {}) =>
    this.http.request({
      path: `/api/rentals/${rentalId}/move-in/complete`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Attach inspection reports and utility meter proofs to move-in record.
   *
   * @tags Rentals
   * @name UploadMoveInDocuments
   * @summary Upload Move In Documents
   * @request POST:/api/rentals/{rental_id}/move-in/documents
   * @secure
   */
  uploadMoveInDocuments = (rentalId, data, params = {}) =>
    this.http.request({
      path: `/api/rentals/${rentalId}/move-in/documents`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Schedule a move-out for a rental.
   *
   * @tags Rentals
   * @name ScheduleMoveOut
   * @summary Schedule Move Out
   * @request POST:/api/rentals/{rental_id}/move-out
   * @secure
   */
  scheduleMoveOut = (rentalId, data, params = {}) =>
    this.http.request({
      path: `/api/rentals/${rentalId}/move-out`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Get move-out details for a rental.
   *
   * @tags Rentals
   * @name GetMoveOut
   * @summary Get Move Out
   * @request GET:/api/rentals/{rental_id}/move-out
   * @secure
   */
  getMoveOut = (rentalId, params = {}) =>
    this.http.request({
      path: `/api/rentals/${rentalId}/move-out`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update move-out details.
   *
   * @tags Rentals
   * @name UpdateMoveOut
   * @summary Update Move Out
   * @request PATCH:/api/rentals/{rental_id}/move-out
   * @secure
   */
  updateMoveOut = (rentalId, data, params = {}) =>
    this.http.request({
      path: `/api/rentals/${rentalId}/move-out`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Mark move-out as completed.
   *
   * @tags Rentals
   * @name CompleteMoveOut
   * @summary Complete Move Out
   * @request POST:/api/rentals/{rental_id}/move-out/complete
   * @secure
   */
  completeMoveOut = (rentalId, params = {}) =>
    this.http.request({
      path: `/api/rentals/${rentalId}/move-out/complete`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Automated security deposit reconciliation for move-out.
   *
   * @tags Rentals
   * @name ReconcileMoveOut
   * @summary Reconcile Move Out
   * @request POST:/api/rentals/{rental_id}/move-out/reconcile
   * @secure
   */
  reconcileMoveOut = (rentalId, data, params = {}) =>
    this.http.request({
      path: `/api/rentals/${rentalId}/move-out/reconcile`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Generate turnover maintenance work orders from move-out inspection deficiencies.
   *
   * @tags Rentals
   * @name GenerateTurnover
   * @summary Generate Turnover
   * @request POST:/api/rentals/{rental_id}/move-out/generate-turnover
   * @secure
   */
  generateTurnover = (rentalId, data, params = {}) =>
    this.http.request({
      path: `/api/rentals/${rentalId}/move-out/generate-turnover`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieve Chilean statutory Concierge Authorization Letter as metadata JSON or ReportLab PDF.
   *
   * @tags Rentals
   * @name GetConciergeLetter
   * @summary Get Concierge Letter
   * @request GET:/api/rentals/{rental_id}/move-out/concierge-letter/{work_order_id}
   * @secure
   */
  getConciergeLetter = (rentalId, workOrderId, query, params = {}) =>
    this.http.request({
      path: `/api/rentals/${rentalId}/move-out/concierge-letter/${workOrderId}`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get payment obligations/expectations for a contract
   *
   * @tags Rentals
   * @name GetContractObligations
   * @summary Get payment schedules for a contract (legacy alias)
   * @request GET:/api/rentals/payments/schedules/{contract_id}
   * @secure
   */
  getContractObligations = (contractId, params = {}) =>
    this.http.request({
      path: `/api/rentals/payments/schedules/${contractId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get payment obligations/expectations for a contract
   *
   * @tags Rentals
   * @name GetContractObligations2
   * @summary Get payment expectations for a contract
   * @request GET:/api/rentals/payments/expectations/{contract_id}
   * @originalName getContractObligations
   * @duplicate
   * @secure
   */
  getContractObligations2 = (contractId, params = {}) =>
    this.http.request({
      path: `/api/rentals/payments/expectations/${contractId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get payment obligations/expectations for a contract
   *
   * @tags Rentals
   * @name GetContractObligations3
   * @summary Get Contract Obligations
   * @request GET:/api/rentals/payments/obligations/{contract_id}
   * @originalName getContractObligations
   * @duplicate
   * @secure
   */
  getContractObligations3 = (contractId, params = {}) =>
    this.http.request({
      path: `/api/rentals/payments/obligations/${contractId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Record a payment transaction
   *
   * @tags Rentals
   * @name CreateTransaction
   * @summary Create Transaction
   * @request POST:/api/rentals/payments/transactions
   * @secure
   */
  createTransaction = (data, params = {}) =>
    this.http.request({
      path: `/api/rentals/payments/transactions`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description List all payment transactions for the organization (Restricted to Management)
   *
   * @tags Rentals
   * @name GetAllTransactions
   * @summary Get All Transactions
   * @request GET:/api/rentals/payments/transactions
   * @secure
   */
  getAllTransactions = (query, params = {}) =>
    this.http.request({
      path: `/api/rentals/payments/transactions`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Reconcile a transaction against obligations
   *
   * @tags Rentals
   * @name ReconcilePayment
   * @summary Reconcile Payment
   * @request POST:/api/rentals/payments/reconcile
   * @secure
   */
  reconcilePayment = (data, params = {}) =>
    this.http.request({
      path: `/api/rentals/payments/reconcile`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Get all line items for a rental payment obligation
   *
   * @tags Rentals
   * @name GetLineItems
   * @summary Get Line Items
   * @request GET:/api/rentals/payments/obligations/{obligation_id}/line-items
   * @secure
   */
  getLineItems = (obligationId, params = {}) =>
    this.http.request({
      path: `/api/rentals/payments/obligations/${obligationId}/line-items`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Add a line item to a rental payment obligation
   *
   * @tags Rentals
   * @name AddLineItem
   * @summary Add Line Item
   * @request POST:/api/rentals/payments/obligations/{obligation_id}/line-items
   * @secure
   */
  addLineItem = (obligationId, data, params = {}) =>
    this.http.request({
      path: `/api/rentals/payments/obligations/${obligationId}/line-items`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Delete a line item from a rental payment obligation
   *
   * @tags Rentals
   * @name DeleteLineItem
   * @summary Delete Line Item
   * @request DELETE:/api/rentals/payments/obligations/{obligation_id}/line-items/{item_id}
   * @secure
   */
  deleteLineItem = (obligationId, itemId, params = {}) =>
    this.http.request({
      path: `/api/rentals/payments/obligations/${obligationId}/line-items/${itemId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description Generate AFIP RG 4004 compliant JSON export for selected payments.
   *
   * @tags Rentals
   * @name ExportAfipInvoices
   * @summary Export Afip Invoices
   * @request POST:/api/rentals/payments/export-afip
   * @secure
   */
  exportAfipInvoices = (data, params = {}) =>
    this.http.request({
      path: `/api/rentals/payments/export-afip`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Create a rental.
   *
   * @tags Rentals
   * @name CreateRental
   * @summary Create Rental
   * @request POST:/api/rentals
   * @secure
   */
  createRental = (data, params = {}) =>
    this.http.request({
      path: `/api/rentals`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description List rentals.
   *
   * @tags Rentals
   * @name ListRentals
   * @summary List Rentals
   * @request GET:/api/rentals
   * @secure
   */
  listRentals = (query, params = {}) =>
    this.http.request({
      path: `/api/rentals`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get a rental by ID.
   *
   * @tags Rentals
   * @name GetRental
   * @summary Get Rental
   * @request GET:/api/rentals/{rental_id}
   * @secure
   */
  getRental = (rentalId, params = {}) =>
    this.http.request({
      path: `/api/rentals/${rentalId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update a rental.
   *
   * @tags Rentals
   * @name UpdateRental
   * @summary Update Rental
   * @request PUT:/api/rentals/{rental_id}
   * @secure
   */
  updateRental = (rentalId, data, params = {}) =>
    this.http.request({
      path: `/api/rentals/${rentalId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Delete a rental.
   *
   * @tags Rentals
   * @name DeleteRental
   * @summary Delete Rental
   * @request DELETE:/api/rentals/{rental_id}
   * @secure
   */
  deleteRental = (rentalId, params = {}) =>
    this.http.request({
      path: `/api/rentals/${rentalId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description Explicitly activate a rental agreement, transitioning its status to ACTIVE.
   *
   * @tags Rentals
   * @name ActivateRental
   * @summary Activate Rental
   * @request POST:/api/rentals/{rental_id}/activate
   * @secure
   */
  activateRental = (rentalId, params = {}) =>
    this.http.request({
      path: `/api/rentals/${rentalId}/activate`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Bind a verified co-signer / aval or rental guarantee to an active rental contract.
   *
   * @tags Rentals
   * @name BindCoSigner
   * @summary Bind Co Signer
   * @request POST:/api/rentals/{rental_id}/co-signer/bind
   * @secure
   */
  bindCoSigner = (rentalId, data, params = {}) =>
    this.http.request({
      path: `/api/rentals/${rentalId}/co-signer/bind`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Renew a rental lease, recording renewal terms, linking extension contract, and transitioning status to RENEWED.
   *
   * @tags Rentals
   * @name RenewRental
   * @summary Renew Rental
   * @request POST:/api/rentals/{rental_id}/renew
   * @secure
   */
  renewRental = (rentalId, data, params = {}) =>
    this.http.request({
      path: `/api/rentals/${rentalId}/renew`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description File an insurance/fianza morosity claim with the guarantee provider due to tenant default.
   *
   * @tags Rentals
   * @name FileGuaranteeClaim
   * @summary File Morosity Claim with Guarantee Provider
   * @request POST:/api/rentals/{rental_id}/guarantees/{guarantee_id}/claim
   * @secure
   */
  fileGuaranteeClaim = (rentalId, guaranteeId, data, params = {}) =>
    this.http.request({
      path: `/api/rentals/${rentalId}/guarantees/${guaranteeId}/claim`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description List all active or historic digital guarantee policies associated with this rental lease.
   *
   * @tags Rentals
   * @name ListRentalGuarantees
   * @summary List Guarantees for Rental
   * @request GET:/api/rentals/{rental_id}/guarantees
   * @secure
   */
  listRentalGuarantees = (rentalId, params = {}) =>
    this.http.request({
      path: `/api/rentals/${rentalId}/guarantees`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Generate formal legal default notice draft for overdue rental: - Chile: Formal pre-judicial notice under Ley N° 21.461 ('Ley Devuélveme mi Casa'). - Argentina: Carta Documento de Intimación de Pago under Arts. 1219 y 1222 CCyC.
   *
   * @tags Rentals
   * @name GenerateLegalNotice
   * @summary Generate Legal Notice
   * @request POST:/api/rentals/{rental_id}/legal-notices/generate
   * @secure
   */
  generateLegalNotice = (rentalId, data, params = {}) =>
    this.http.request({
      path: `/api/rentals/${rentalId}/legal-notices/generate`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Mark legal default notice as dispatched/served (tracking letter number, postal code, date) and transition rental status to DEFAULT_NOTICE_ISSUED.
   *
   * @tags Rentals
   * @name IssueLegalNotice
   * @summary Issue Legal Notice
   * @request POST:/api/rentals/{rental_id}/legal-notices/{notice_id}/issue
   * @secure
   */
  issueLegalNotice = (rentalId, noticeId, data, params = {}) =>
    this.http.request({
      path: `/api/rentals/${rentalId}/legal-notices/${noticeId}/issue`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description List issued and draft legal default notices for the rental.
   *
   * @tags Rentals
   * @name ListLegalNotices
   * @summary List Legal Notices
   * @request GET:/api/rentals/{rental_id}/legal-notices
   * @secure
   */
  listLegalNotices = (rentalId, params = {}) =>
    this.http.request({
      path: `/api/rentals/${rentalId}/legal-notices`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Calculate Argentine provincial stamp tax (Impuesto de Sellos) breakdown: - Jurisdictions: CABA (exempt residential / 0.5% commercial), PBA (0.5% res / 1.2% com), etc. - Contract valuation = monthly_rent * duration_months. - Landlord vs Tenant statutory split (typically 50/50).
   *
   * @tags Rentals
   * @name CalculateStampTax
   * @summary Calculate Stamp Tax
   * @request POST:/api/rentals/{rental_id}/stamp-tax/calculate
   * @secure
   */
  calculateStampTax = (rentalId, data, params = {}) =>
    this.http.request({
      path: `/api/rentals/${rentalId}/stamp-tax/calculate`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Save stamp tax record for rental and optionally append tenant share to payment expectations.
   *
   * @tags Rentals
   * @name SaveStampTax
   * @summary Save Stamp Tax
   * @request POST:/api/rentals/{rental_id}/stamp-tax
   * @secure
   */
  saveStampTax = (rentalId, data, params = {}) =>
    this.http.request({
      path: `/api/rentals/${rentalId}/stamp-tax`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieve current stamp tax record for rental.
   *
   * @tags Rentals
   * @name GetStampTax
   * @summary Get Stamp Tax
   * @request GET:/api/rentals/{rental_id}/stamp-tax
   * @secure
   */
  getStampTax = (rentalId, params = {}) =>
    this.http.request({
      path: `/api/rentals/${rentalId}/stamp-tax`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Mark stamp tax as paid with agency receipt number and digital proof of filing document.
   *
   * @tags Rentals
   * @name UploadStampTaxProof
   * @summary Upload Stamp Tax Proof
   * @request POST:/api/rentals/{rental_id}/stamp-tax/{tax_id}/upload-proof
   * @secure
   */
  uploadStampTaxProof = (rentalId, taxId, data, params = {}) =>
    this.http.request({
      path: `/api/rentals/${rentalId}/stamp-tax/${taxId}/upload-proof`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Initiate Autorización Notarial de Firma (ANF) with an online notary provider (FirmaVirtual, iDok, Acepta) for a Chilean rental agreement under Ley N° 21.461.
   *
   * @tags Rentals
   * @name InitiateNotaryAuthorization
   * @summary Initiate Notary Authorization
   * @request POST:/api/rentals/{rental_id}/notary-authorization/initiate
   * @secure
   */
  initiateNotaryAuthorization = (rentalId, data, params = {}) =>
    this.http.request({
      path: `/api/rentals/${rentalId}/notary-authorization/initiate`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieve current notary authorization workflow status and certification metadata.
   *
   * @tags Rentals
   * @name GetNotaryAuthorization
   * @summary Get Notary Authorization
   * @request GET:/api/rentals/{rental_id}/notary-authorization
   * @secure
   */
  getNotaryAuthorization = (rentalId, params = {}) =>
    this.http.request({
      path: `/api/rentals/${rentalId}/notary-authorization`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Attach CBR Certificado de Dominio Vigente (ownership title deed) to fulfill the evidentiary requirement of Ley N° 21.461.
   *
   * @tags Rentals
   * @name AttachDominioVigente
   * @summary Attach Dominio Vigente
   * @request POST:/api/rentals/{rental_id}/notary-authorization/attach-deed
   * @secure
   */
  attachDominioVigente = (rentalId, data, params = {}) =>
    this.http.request({
      path: `/api/rentals/${rentalId}/notary-authorization/attach-deed`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Direct callback endpoint for a specific rental to receive asynchronous notary approval.
   *
   * @tags Rentals
   * @name NotaryProviderCallback
   * @summary Notary Provider Callback
   * @request POST:/api/rentals/{rental_id}/notary-authorization/callback
   */
  notaryProviderCallback = (rentalId, data, params = {}) =>
    this.http.request({
      path: `/api/rentals/${rentalId}/notary-authorization/callback`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description General webhook endpoint for certified e-signature and online notary providers.
   *
   * @tags Rentals
   * @name NotaryProviderWebhook
   * @summary Notary Provider Webhook
   * @request POST:/api/rentals/notary-authorization/webhook
   */
  notaryProviderWebhook = (data, params = {}) =>
    this.http.request({
      path: `/api/rentals/notary-authorization/webhook`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Download or generate consolidated evidentiary dossier for fast-track eviction (Procedimiento Monitorio) under Ley N° 21.461 ('Ley Devuélveme mi Casa') and Ley N° 18.101.
   *
   * @tags Rentals
   * @name GetEvictionPack
   * @summary Get Eviction Pack
   * @request GET:/api/rentals/{rental_id}/notary-authorization/eviction-pack
   * @secure
   */
  getEvictionPack = (rentalId, params = {}) =>
    this.http.request({
      path: `/api/rentals/${rentalId}/notary-authorization/eviction-pack`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Schedule a remote video call notarization session with Daily.co room link and tokens.
   *
   * @tags Rentals
   * @name ScheduleVideoNotarization
   * @summary Schedule Video Notarization
   * @request POST:/api/rentals/{rental_id}/video-notarization/schedule
   * @secure
   */
  scheduleVideoNotarization = (rentalId, data, params = {}) =>
    this.http.request({
      path: `/api/rentals/${rentalId}/video-notarization/schedule`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieve current video notarization session details for a rental.
   *
   * @tags Rentals
   * @name GetVideoNotarization
   * @summary Get Video Notarization
   * @request GET:/api/rentals/{rental_id}/video-notarization
   * @secure
   */
  getVideoNotarization = (rentalId, params = {}) =>
    this.http.request({
      path: `/api/rentals/${rentalId}/video-notarization`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Attach tamper-evident encrypted video recording and SHA-256 hash.
   *
   * @tags Rentals
   * @name AttachVideoRecording
   * @summary Attach Video Recording
   * @request POST:/api/rentals/{rental_id}/video-notarization/recording
   * @secure
   */
  attachVideoRecording = (rentalId, data, params = {}) =>
    this.http.request({
      path: `/api/rentals/${rentalId}/video-notarization/recording`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Certify and mark video notarization session as completed.
   *
   * @tags Rentals
   * @name CompleteVideoNotarization
   * @summary Complete Video Notarization
   * @request POST:/api/rentals/{rental_id}/video-notarization/complete
   * @secure
   */
  completeVideoNotarization = (rentalId, data, params = {}) =>
    this.http.request({
      path: `/api/rentals/${rentalId}/video-notarization/complete`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieve monthly owner financial statements for a rental agreement.
   *
   * @tags Rentals
   * @name ListOwnerStatements
   * @summary List Owner Statements
   * @request GET:/api/rentals/{rental_id}/owner-statements
   * @secure
   */
  listOwnerStatements = (rentalId, query, params = {}) =>
    this.http.request({
      path: `/api/rentals/${rentalId}/owner-statements`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Compile and stream official monthly Owner Statement PDF with rent, fee, and expense breakdown.
   *
   * @tags Rentals
   * @name DownloadOwnerStatementPdf
   * @summary Download Owner Statement Pdf
   * @request GET:/api/rentals/owner-statements/{statement_id}/pdf
   * @secure
   */
  downloadOwnerStatementPdf = (statementId, params = {}) =>
    this.http.request({
      path: `/api/rentals/owner-statements/${statementId}/pdf`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Record or hold security deposit for a rental
   *
   * @tags Rentals
   * @name HoldDeposit
   * @summary Hold Deposit
   * @request POST:/api/rentals/{rental_id}/deposit/hold
   * @secure
   */
  holdDeposit = (rentalId, data, params = {}) =>
    this.http.request({
      path: `/api/rentals/${rentalId}/deposit/hold`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Get security deposit ledger statement and deductions for a rental
   *
   * @tags Rentals
   * @name GetDeposit
   * @summary Get Deposit
   * @request GET:/api/rentals/{rental_id}/deposit
   * @secure
   */
  getDeposit = (rentalId, params = {}) =>
    this.http.request({
      path: `/api/rentals/${rentalId}/deposit`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Add itemized deduction against held security deposit
   *
   * @tags Rentals
   * @name AddDeduction
   * @summary Add Deduction
   * @request POST:/api/rentals/{rental_id}/deposit/deductions
   * @secure
   */
  addDeduction = (rentalId, data, params = {}) =>
    this.http.request({
      path: `/api/rentals/${rentalId}/deposit/deductions`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Open formal dispute on deposit holding/deductions
   *
   * @tags Rentals
   * @name DisputeDeposit
   * @summary Dispute Deposit
   * @request POST:/api/rentals/{rental_id}/deposit/dispute
   * @secure
   */
  disputeDeposit = (rentalId, data, params = {}) =>
    this.http.request({
      path: `/api/rentals/${rentalId}/deposit/dispute`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Resolve formal dispute on deposit holding
   *
   * @tags Rentals
   * @name ResolveDispute
   * @summary Resolve Dispute
   * @request POST:/api/rentals/{rental_id}/deposit/resolve-dispute
   * @secure
   */
  resolveDispute = (rentalId, data, params = {}) =>
    this.http.request({
      path: `/api/rentals/${rentalId}/deposit/resolve-dispute`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Process full or partial deposit refund after deductions
   *
   * @tags Rentals
   * @name ProcessRefund
   * @summary Process Refund
   * @request POST:/api/rentals/{rental_id}/deposit/refund
   * @secure
   */
  processRefund = (rentalId, data, params = {}) =>
    this.http.request({
      path: `/api/rentals/${rentalId}/deposit/refund`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Register deposit with trust account and deposit type
   *
   * @tags Rentals
   * @name RegisterTrustDeposit
   * @summary Register Trust Deposit
   * @request POST:/api/rentals/{rental_id}/deposits/trust
   * @secure
   */
  registerTrustDeposit = (rentalId, data, params = {}) =>
    this.http.request({
      path: `/api/rentals/${rentalId}/deposits/trust`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description List deposits, trust details, and accrued interest history
   *
   * @tags Rentals
   * @name ListTrustDeposits
   * @summary List Trust Deposits
   * @request GET:/api/rentals/{rental_id}/deposits/trust
   * @secure
   */
  listTrustDeposits = (rentalId, params = {}) =>
    this.http.request({
      path: `/api/rentals/${rentalId}/deposits/trust`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Calculate accrued interest or inflation adjustment for given jurisdiction
   *
   * @tags Rentals
   * @name CalculateDepositInterest
   * @summary Calculate Deposit Interest
   * @request POST:/api/rentals/{rental_id}/deposits/interest/calculate
   * @secure
   */
  calculateDepositInterest = (rentalId, data, params = {}) =>
    this.http.request({
      path: `/api/rentals/${rentalId}/deposits/interest/calculate`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Generate complete move-out legal settlement preview (adjusted base amount + accrued interest - deductions = net refund)
   *
   * @tags Rentals
   * @name CalculateDepositSettlement
   * @summary Calculate Deposit Settlement
   * @request POST:/api/rentals/{rental_id}/deposits/settlement/calculate
   * @secure
   */
  calculateDepositSettlement = (rentalId, data, params = {}) =>
    this.http.request({
      path: `/api/rentals/${rentalId}/deposits/settlement/calculate`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Mark an accrued deposit interest record as paid out to tenant
   *
   * @tags Rentals
   * @name PayoutDepositInterest
   * @summary Payout Deposit Interest
   * @request POST:/api/rentals/{rental_id}/deposits/interest/{interest_id}/payout
   * @secure
   */
  payoutDepositInterest = (rentalId, interestId, params = {}) =>
    this.http.request({
      path: `/api/rentals/${rentalId}/deposits/interest/${interestId}/payout`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update deposit record lifecycle status (e.g. REFUNDED, FORFEITED, PARTIALLY_REFUNDED)
   *
   * @tags Rentals
   * @name UpdateDepositStatus
   * @summary Update Deposit Status
   * @request PATCH:/api/rentals/{rental_id}/deposits/{deposit_id}/status
   * @secure
   */
  updateDepositStatus = (rentalId, depositId, data, params = {}) =>
    this.http.request({
      path: `/api/rentals/${rentalId}/deposits/${depositId}/status`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Rentals
   * @name ToggleRequirement
   * @summary Toggle Requirement
   * @request POST:/api/rentals/{rental_id}/insurance/requirement
   * @secure
   */
  toggleRequirement = (rentalId, query, params = {}) =>
    this.http.request({
      path: `/api/rentals/${rentalId}/insurance/requirement`,
      method: "POST",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Rentals
   * @name UploadPolicy
   * @summary Upload Policy
   * @request POST:/api/rentals/{rental_id}/insurance
   * @secure
   */
  uploadPolicy = (rentalId, data, params = {}) =>
    this.http.request({
      path: `/api/rentals/${rentalId}/insurance`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Rentals
   * @name VerifyCompliance
   * @summary Verify Compliance
   * @request POST:/api/rentals/{rental_id}/insurance/verify
   * @secure
   */
  verifyCompliance = (rentalId, query, params = {}) =>
    this.http.request({
      path: `/api/rentals/${rentalId}/insurance/verify`,
      method: "POST",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Rentals
   * @name GetCompliance
   * @summary Get Compliance
   * @request GET:/api/rentals/{rental_id}/insurance/compliance
   * @secure
   */
  getCompliance = (rentalId, params = {}) =>
    this.http.request({
      path: `/api/rentals/${rentalId}/insurance/compliance`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Issue an AFIP RG 4004 electronic invoice for a rental contract.
   *
   * @tags Rentals
   * @name IssueAfipInvoice
   * @summary Issue Afip Invoice
   * @request POST:/api/rentals/{organization_id}/taxes/ar/afip-invoice
   * @secure
   */
  issueAfipInvoice = (organizationId, data, params = {}) =>
    this.http.request({
      path: `/api/rentals/${organizationId}/taxes/ar/afip-invoice`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Generate the SII DJ 1835 TXT file for the given year (Chile — Admin Only).
   *
   * @tags Rentals
   * @name ExportDj1835
   * @summary Export Dj1835
   * @request GET:/api/rentals/{organization_id}/taxes/cl/dj1835-export
   * @secure
   */
  exportDj1835 = (organizationId, query, params = {}) =>
    this.http.request({
      path: `/api/rentals/${organizationId}/taxes/cl/dj1835-export`,
      method: "GET",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * @description Issue a Chilean SII DTE (Boleta / Factura Electrónica) for a rental contract.
   *
   * @tags Rentals
   * @name IssueSiiDte
   * @summary Issue Sii Dte
   * @request POST:/api/rentals/{organization_id}/taxes/cl/sii-dte
   * @secure
   */
  issueSiiDte = (organizationId, data, params = {}) =>
    this.http.request({
      path: `/api/rentals/${organizationId}/taxes/cl/sii-dte`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Fetch official daily UF rate in Chilean Pesos (CLP) from Central Bank/mindicador.
   *
   * @tags Rentals
   * @name GetUfRate
   * @summary Get Uf Rate
   * @request GET:/api/rentals/exchange-rates/uf
   * @secure
   */
  getUfRate = (query, params = {}) =>
    this.http.request({
      path: `/api/rentals/exchange-rates/uf`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Convert amount between supported rental currencies with real-time/cached parity rates.
   *
   * @tags Rentals
   * @name ConvertCurrency
   * @summary Convert Currency
   * @request GET:/api/rentals/exchange-rates/convert
   * @secure
   */
  convertCurrency = (query, params = {}) =>
    this.http.request({
      path: `/api/rentals/exchange-rates/convert`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get current exchange rate multiplier between two currencies.
   *
   * @tags Rentals
   * @name GetExchangeRate
   * @summary Get Exchange Rate
   * @request GET:/api/rentals/exchange-rates/rate
   * @secure
   */
  getExchangeRate = (query, params = {}) =>
    this.http.request({
      path: `/api/rentals/exchange-rates/rate`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Preview or compute rent indexation adjustment across Chilean UF/IPC and Argentine ICL/IPC.
   *
   * @tags Rentals
   * @name CalculateRentAdjustment
   * @summary Calculate Rent Adjustment
   * @request POST:/api/rentals/rent-adjustments/calculate
   * @secure
   */
  calculateRentAdjustment = (data, params = {}) =>
    this.http.request({
      path: `/api/rentals/rent-adjustments/calculate`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Apply indexation adjustment to active rental entity and record adjustment date.
   *
   * @tags Rentals
   * @name ApplyRentalAdjustment
   * @summary Apply Rental Adjustment
   * @request POST:/api/rentals/{rental_id}/apply-adjustment
   * @secure
   */
  applyRentalAdjustment = (rentalId, query, params = {}) =>
    this.http.request({
      path: `/api/rentals/${rentalId}/apply-adjustment`,
      method: "POST",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Intake and record a new building expense statement (Gastos Comunes / Expensas).
   *
   * @tags Rentals
   * @name CreateBuildingExpense
   * @summary Create Building Expense
   * @request POST:/api/rentals/building-expenses
   * @secure
   */
  createBuildingExpense = (data, params = {}) =>
    this.http.request({
      path: `/api/rentals/building-expenses`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description List all building expense statements for a given rental.
   *
   * @tags Rentals
   * @name ListBuildingExpensesByRental
   * @summary List Building Expenses By Rental
   * @request GET:/api/rentals/building-expenses/rental/{rental_id}
   * @secure
   */
  listBuildingExpensesByRental = (rentalId, params = {}) =>
    this.http.request({
      path: `/api/rentals/building-expenses/rental/${rentalId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description List all building expense statements for a given property.
   *
   * @tags Rentals
   * @name ListBuildingExpensesByProperty
   * @summary List Building Expenses By Property
   * @request GET:/api/rentals/building-expenses/property/{property_id}
   * @secure
   */
  listBuildingExpensesByProperty = (propertyId, params = {}) =>
    this.http.request({
      path: `/api/rentals/building-expenses/property/${propertyId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Auto-extract / simulate OCR parse of a monthly building expense statement.
   *
   * @tags Rentals
   * @name ParseBuildingExpense
   * @summary Parse Building Expense
   * @request POST:/api/rentals/building-expenses/parse
   * @secure
   */
  parseBuildingExpense = (data, params = {}) =>
    this.http.request({
      path: `/api/rentals/building-expenses/parse`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Calculate and preview the ordinary (tenant) vs extraordinary (owner) split.
   *
   * @tags Rentals
   * @name CalculateBuildingExpenseSplit
   * @summary Calculate Building Expense Split
   * @request POST:/api/rentals/building-expenses/calculate-split
   * @secure
   */
  calculateBuildingExpenseSplit = (data, params = {}) =>
    this.http.request({
      path: `/api/rentals/building-expenses/calculate-split`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieve details of a building expense statement.
   *
   * @tags Rentals
   * @name GetBuildingExpense
   * @summary Get Building Expense
   * @request GET:/api/rentals/building-expenses/{statement_id}
   * @secure
   */
  getBuildingExpense = (statementId, params = {}) =>
    this.http.request({
      path: `/api/rentals/building-expenses/${statementId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update line items or amounts of a building expense statement.
   *
   * @tags Rentals
   * @name UpdateBuildingExpense
   * @summary Update Building Expense
   * @request PUT:/api/rentals/building-expenses/{statement_id}
   * @secure
   */
  updateBuildingExpense = (statementId, data, params = {}) =>
    this.http.request({
      path: `/api/rentals/building-expenses/${statementId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Apply ordinary/extraordinary ledger split: - Appends ordinary fees to tenant's payment obligation - Appends extraordinary fees as owner statement deduction
   *
   * @tags Rentals
   * @name ApplyBuildingExpenseSplit
   * @summary Apply Building Expense Split
   * @request POST:/api/rentals/building-expenses/{statement_id}/apply-split
   * @secure
   */
  applyBuildingExpenseSplit = (statementId, params = {}) =>
    this.http.request({
      path: `/api/rentals/building-expenses/${statementId}/apply-split`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
}
